module.exports = __webpack_public_path__ + "img/kredi-kartlari.c098f529.png";